import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-job-candidate',
  templateUrl: './page-job-candidate.component.html',
  styleUrls: ['./page-job-candidate.component.css']
})
export class PageJobCandidateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
